var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c('div',{staticClass:"position-fixed progressLoaderWrapper"},[_c('div',{staticClass:"progressLoader"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }